import axios from 'axios'
import { apiUrl } from './config'

const ReminderApi = {
    getRemindersHistory: async (triggerFor, triggerId) => {
        return axios.post(`${apiUrl}/get-reminders-history`, { triggerFor, triggerId })
    }
}

export default ReminderApi
